import { EntryItemType } from '@/feature/entries-pickem/components/EntriesList';
import { CashableEntry } from '@/feature/entries-pickem/hooks/use-cash-out';
import { useFantasyCashoutEnabled } from '@/utils/ab-testing';

export type EntryAvailableControls =
    | { canCancel: false; canCashout: true; cashableEntry: CashableEntry }
    | {
          canCancel: true;
          canCashout: false;
          cashableEntry: null;
      }
    | {
          canCancel: false;
          canCashout: false;
          cashableEntry: null;
      };

export const resolveEntryAvailableActions = (
    entry: EntryItemType | undefined,
    isCashoutFeatureEnabled: boolean
): EntryAvailableControls => {
    const entryCanBeCanceled = entry?.canBeCanceled ?? false;
    const entryCanBeCashedOut = entry?.canBeCashedout ?? false;

    const canCancel = entryCanBeCanceled;
    const canCashout = isCashoutFeatureEnabled && entryCanBeCashedOut && !entryCanBeCanceled;

    const cashableEntry = entry ? { id: entry.id, status: entry.status, canBeCashedout: entry?.canBeCashedout } : null;

    if (canCancel) {
        return {
            canCancel: true,
            canCashout: false,
            cashableEntry: null,
        };
    } else {
        if (canCashout && cashableEntry) {
            return {
                canCancel: false,
                canCashout: true,
                cashableEntry,
            };
        }
    }
    return {
        canCashout: false,
        canCancel: false,
        cashableEntry: null,
    };
};

export const useEntryAvailableActions = (entry: EntryItemType | undefined): EntryAvailableControls => {
    const isCashoutFeatureEnabled = useFantasyCashoutEnabled();
    return resolveEntryAvailableActions(entry, isCashoutFeatureEnabled);
};
